import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Agency.css";
import { Box } from "@mui/system";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { agencyApi } from "../../API/Api";
import { useNavigate } from "react-router-dom";

const Agency = () => {
  const navigate = useNavigate();
  const [agencyData, setAgencyData] = useState([]);

  React.useEffect(() => {
    fetch(agencyApi)
      .then((res) => res.json())
      .then((result) => {
        setAgencyData(result);
      });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 5,
    slidesToScroll: 1,
    draggable: false,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 24000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          // initialSlide: 2,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
    ],
  };
  return (
    <Box sx={{ padding: "20px", pt: "20px" }}>
      {agencyData.length > 1 && (
        <Box>
          <Grid container spacing={2}>
            {agencyData.map((element) => (
              <Grid item xs={6} sm={6} md={3} lg={3} key={element.c_refer}>
                <Box
                  sx={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "hidden",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": { transform: "scale(1.03)" },
                  }}
                  className="agency"
                >
                  {/* Image background with overlay */}
                  <Box
                    component="img"
                    src={element.logo}
                    alt="Agency Logo"
                    sx={{
                      width: "100%",
                      height: "160px",
                      objectFit: "cover",
                      filter: "brightness(0.8)",
                    }}
                  />

                  {/* Gradient overlay at bottom */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      width: "100%",
                      height: "40%",
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                    }}
                  />

                  {/* Content Box */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      width: "100%",
                      px: 2,
                      py: 1.5,
                      backdropFilter: "blur(4px)",
                      background: "rgba(255, 255, 255, 0.05)",
                      color: "white",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        textShadow: "1px 1px 3px rgba(0,0,0,0.8)",
                      }}
                    >
                      {element.cname.slice(0, 18) + "..."}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 0.5,
                        color: "#e0e0e0",
                        fontSize: "10pt",
                        textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
                      }}
                    >
                      {element.cslogan.slice(0, 28) + "..."}
                    </Typography>

                    {/* Animated Button */}
                    <Button
                      onClick={() => navigate("/profile/" + element.c_refer)}
                      sx={{
                        mt: 1,
                        fontSize: "10pt",
                        fontWeight: 600,
                        textTransform: "none",
                        px: 2,
                        py: 1,
                        borderRadius: "30px",
                        color: "#fff",
                        background: "linear-gradient(135deg, #00C9A7, #0074E4)",
                        boxShadow: "0px 5px 20px rgba(0,201,167,0.25)",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          background:
                            "linear-gradient(135deg, #00E0B6, #148AFF)",
                        },
                      }}
                    >
                      View Profile
                    </Button>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Stack
            direction={"row"}
            justifyContent="center"
            alignItems={"center"}
            sx={{ padding: "20px", pt: "20px" }}
          >
            <Button
              variant="contained"
              onClick={() => {
                navigate("/agentlist");
              }}
              sx={{
                px: 5,
                py: 1.5,
                fontSize: "16pt",
                fontWeight: 600,
                textTransform: "none",
                background:
                  "linear-gradient(135deg, rgba(0,201,167,0.9), rgba(0,116,228,0.9))",
                borderRadius: "50px",
                boxShadow: "0px 8px 24px rgba(0,201,167,0.3)",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                  background:
                    "linear-gradient(135deg, rgba(0,201,167,1), rgba(0,116,228,1))",
                },
              }}
            >
              Load more...
            </Button>
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default Agency;
